import { useNavigate } from 'react-router-dom';

export default function Categories() {
  const navigate = useNavigate();

  const categories = [
    {
      name: 'Shirts',
      tagline: 'Performance & Style',
      image: 'https://public.readdy.ai/ai/img_res/2c53b2c1d6ca61c7ffd4514ce77492e6.jpg',
      path: '/products?category=shirts'
    },
    {
      name: 'Shorts',
      tagline: 'Built to Move',
      image: 'https://readdy.ai/api/search-image?query=Athletic%20man%20wearing%20premium%20fishing%20shorts%20on%20boat%20deck%2C%20ocean%20blue%20styling%2C%20active%20lifestyle%20photography%2C%20clean%20water%20background%2C%20professional%20outdoor%20apparel%20commercial&width=600&height=800&seq=cat-shorts-v2&orientation=portrait',
      path: '/products?category=shorts'
    },
    {
      name: 'Jackets',
      tagline: 'Weather Protection',
      image: 'https://readdy.ai/api/search-image?query=Angler%20wearing%20premium%20fishing%20jacket%20in%20challenging%20weather%20conditions%2C%20ocean%20blue%20accents%2C%20dramatic%20outdoor%20photography%2C%20clean%20background%2C%20high-end%20outerwear%20commercial%20style&width=600&height=800&seq=cat-jackets-v2&orientation=portrait',
      path: '/products?category=jackets'
    },
    {
      name: 'Pants',
      tagline: 'Durability Meets Comfort',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fisherman%20wearing%20premium%20fishing%20pants%20on%20boat%2C%20ocean%20blue%20color%20palette%2C%20active%20lifestyle%20photography%2C%20clean%20water%20background%2C%20high-end%20outdoor%20apparel%20commercial&width=600&height=800&seq=cat-pants-v2&orientation=portrait',
      path: '/products?category=pants'
    },
    {
      name: 'Hats',
      tagline: 'Sun Protection',
      image: 'https://readdy.ai/api/search-image?query=Premium%20fishing%20hats%20and%20caps%20collection%20with%20ocean%20blue%20branding%2C%20professional%20product%20lifestyle%20photography%2C%20clean%20modern%20background%20with%20water%20elements%2C%20high-end%20headwear%20commercial%20style&width=600&height=800&seq=cat-hats-v2&orientation=portrait',
      path: '/products?category=hats'
    },
    {
      name: 'Drinkware',
      tagline: 'Stay Hydrated',
      image: 'https://readdy.ai/api/search-image?query=Premium%20fishing%20drinkware%20collection%20including%20insulated%20bottles%20and%20tumblers%20with%20ocean%20blue%20branding%2C%20professional%20product%20photography%20on%20boat%20deck%2C%20clean%20water%20background%2C%20high-end%20lifestyle%20commercial&width=600&height=800&seq=cat-drink-v2&orientation=portrait',
      path: '/products?category=drinkware'
    }
  ];

  return (
    <section id="categories" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4 tracking-tight">
            SHOP BY CATEGORY
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            Explore our complete collection of premium fishing gear and apparel
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {categories.map((category, index) => (
            <div 
              key={index} 
              className="group relative overflow-hidden rounded-lg cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-500"
              onClick={() => navigate(category.path)}
            >
              {/* Image */}
              <div className="relative h-96 overflow-hidden">
                <img 
                  src={category.image} 
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <p className="text-sm font-semibold text-cyan-400 mb-2 uppercase tracking-widest">
                  {category.tagline}
                </p>
                <h3 className="text-3xl font-black mb-4 uppercase tracking-tight">
                  {category.name}
                </h3>
                <div className="flex items-center text-white group-hover:text-cyan-400 transition-colors">
                  <span className="font-semibold uppercase tracking-wider text-sm">Shop Now</span>
                  <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}